import { Component, OnInit, } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import { MonitorsSlaTeamProductivityCompletionMonitorService } from 'e5core-angular-services';
import { MonitorsSlaTeamProductivityFacetimeMonitorService } from 'e5core-angular-services';
import { MonitorsSlaTeamProductivityCompletionMonitorModel } from 'e5core-angular-services';
import { MonitorsSlaTeamProductivityFacetimeMonitorModel } from 'e5core-angular-services';
import { DatePipe } from '@angular/common';
import { MatSelectChange } from '@angular/material';
import { Observable, of } from 'rxjs';

export interface OptionMonth {
  value: DateRange;
  viewValue: string;
}

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export interface FinalModel {
  completionModel: MonitorsSlaTeamProductivityCompletionMonitorModel;
  faceTimeModel: MonitorsSlaTeamProductivityFacetimeMonitorModel;
}

export class MockCompletionService {
  public getMockedSlaTeamProductivityCompletionCounts(): Observable<MonitorsSlaTeamProductivityCompletionMonitorModel> {
    const incomingData: any = new Array();
    const model: MonitorsSlaTeamProductivityCompletionMonitorModel = new MonitorsSlaTeamProductivityCompletionMonitorModel();
    incomingData.push(
    {
      interval: new Date('2018-12-05T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 15
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 20
        }
      ],
      totalCount: 45
    },
    {
      interval: new Date('2018-12-06T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 12
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 14
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 17
        }
      ],
      totalCount: 43
    },
    {
      interval: new Date('2018-12-07T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 15
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 20
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 25
        }
      ],
      totalCount: 60
    },
    {
      interval: new Date('2018-12-08T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 20
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 30
        }
      ],
      totalCount: 75
    },
    {
      interval: new Date('2018-12-09T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 20
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 25
        }
      ],
      totalCount: 70
    }, {
      interval: new Date('2018-12-10T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 18
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 27
        }
      ],
      totalCount: 70
    },
    {
      interval: new Date('2018-12-11T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 20
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 30
        }
      ],
      totalCount: 75
    },
    {
      interval: new Date('2018-12-12T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 20
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 21
        }
      ],
      totalCount: 51
    },
    {
      interval: new Date('2018-12-13T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 20
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 30
        }
      ],
      totalCount: 75
    },
    {
      interval: new Date('2018-12-14T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 15
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 20
        }
      ],
      totalCount: 45
    },
    {
      interval: new Date('2018-12-15T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 15
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 20
        }
      ],
      totalCount: 45
    },
    {
      interval: new Date('2018-12-16T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 12
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 14
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 17
        }
      ],
      totalCount: 43
    },
    {
      interval: new Date('2018-12-17T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 15
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 20
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 25
        }
      ],
      totalCount: 60
    },
    {
      interval: new Date('2018-12-18T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 20
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 30
        }
      ],
      totalCount: 75
    },
    {
      interval: new Date('2018-12-19T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 20
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 21
        }
      ],
      totalCount: 51
    },
    {
      interval: new Date('2018-12-20T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 18
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 20
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 19
        }
      ],
      totalCount: 57
    },
    {
      interval: new Date('2018-12-21T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 20
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 25
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 30
        }
      ],
      totalCount: 75
    },
    {
      interval: new Date('2018-12-22T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 15
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 20
        }
      ],
      totalCount: 45
    },
    {
      interval: new Date('2018-12-23T11:52:10.113Z'),
      userWorkCounts: [
        {
          userName: 'Rias Gremory',
          completionCount: 10
        },
        {
          userName: 'Mikoto Misaka',
          completionCount: 15
        },
        {
          userName: 'Tohka Yatogami',
          completionCount: 20
        }
      ],
      totalCount: 45
    });
    model.data = incomingData;
    return of(model);
  }
}

export class MockFaceTimeService {
  public getMockedSlaTeamProductivityFacetimeCounts(): Observable<MonitorsSlaTeamProductivityFacetimeMonitorModel> {
    const incomingData: any = new Array();
    const model: MonitorsSlaTeamProductivityFacetimeMonitorModel = new MonitorsSlaTeamProductivityFacetimeMonitorModel();
    incomingData.push(
    {
      interval: new Date('2018-12-05T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 50
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 40
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 30
        }
      ],
      totalCount: 120
    },
    {
      interval: new Date('2018-12-06T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 126
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 70
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 50
        }
      ],
      totalCount: 246
    },
    {
      interval: new Date('2018-12-07T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 86
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 101
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 154
        }
      ],
      totalCount: 341
    },
    {
      interval: new Date('2018-12-08T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 62
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 84
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 93
        }
      ],
      totalCount: 239
    },
    {
      interval: new Date('2018-12-09T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 110
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 120
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 150
        }
      ],
      totalCount: 380
    },
    {
      interval: new Date('2018-12-10T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 80
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 190
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 200
        }
      ],
      totalCount: 470
    },
    {
      interval: new Date('2018-12-11T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 190
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 170
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 140
        }
      ],
      totalCount: 500
    },
    {
      interval: new Date('2018-12-12T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 100
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 90
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 62
        }
      ],
      totalCount: 252
    },
    {
      interval: new Date('2018-12-13T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 80
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 190
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 200
        }
      ],
      totalCount: 470
    },
    {
      interval: new Date('2018-12-14T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 60
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 80
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 90
        }
      ],
      totalCount: 230
    },
    {
      interval: new Date('2018-12-15T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 50
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 40
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 30
        }
      ],
      totalCount: 120
    },
    {
      interval: new Date('2018-12-16T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 126
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 70
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 50
        }
      ],
      totalCount: 246
    },
    {
      interval: new Date('2018-12-17T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 86
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 101
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 154
        }
      ],
      totalCount: 341
    },
    {
      interval: new Date('2018-12-18T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 190
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 170
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 140
        }
      ],
      totalCount: 500
    },
    {
      interval: new Date('2018-12-19T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 100
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 90
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 62
        }
      ],
      totalCount: 252
    },
    {
      interval: new Date('2018-12-20T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 105
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 110
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 115
        }
      ],
      totalCount: 330
    },
    {
      interval: new Date('2018-12-21T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 86
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 101
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 154
        }
      ],
      totalCount: 341
    },
    {
      interval: new Date('2018-12-22T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 62
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 84
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 93
        }
      ],
      totalCount: 239
    },
    {
      interval: new Date('2018-12-23T11:52:10.113Z'),
      userFacetimeCounts: [
        {
          userName: 'Rias Gremory',
          faceTimeCount: 110
        },
        {
          userName: 'Mikoto Misaka',
          faceTimeCount: 120
        },
        {
          userName: 'Tohka Yatogami',
          faceTimeCount: 150
        }
      ],
      totalCount: 380
    });
    model.data = incomingData;
    return of(model);
  }
}

@Component({
  selector: 'e5core-ui-monitor-sla-team-productivity-highcharts',
  templateUrl: './highcharts.component.html',
  styleUrls: ['./highcharts.component.css']
})
export class E5coreUiMonitorSlaTeamProductivityHighchartsComponent implements OnInit {

  constructor(private monitorCompletionService: MonitorsSlaTeamProductivityCompletionMonitorService,
    private monitorFacetimeService: MonitorsSlaTeamProductivityFacetimeMonitorService, private datePipe: DatePipe) {  }

  // Ready up mock services
  mockCompletionService: MockCompletionService = new MockCompletionService();
  mockFaceTimeService: MockFaceTimeService = new MockFaceTimeService();

  finalModel: Observable<FinalModel> = this.mergeServiceCalls(true);

  model: FinalModel;
  completionModel: MonitorsSlaTeamProductivityCompletionMonitorModel;
  faceTimeModel: MonitorsSlaTeamProductivityFacetimeMonitorModel;
  Highcharts = Highcharts;
  chartConstructor = 'chart';
  chartOptions = this.createChartOptions();
  chartCallback = null; // optional function, defaults to null
  updateFlag = false; // optional boolean
  oneToOneFlag = true; // optional boolean, defaults to false
  runOutsideAngularFlag = false;

  // Month drop-down variables
  currentDate: Date = new Date();
  optionMonths: OptionMonth[];
  currentDateRange: DateRange = {
    startDate: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1),
    endDate: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0, 23, 59, 59, 999)
  };
  selectedOptionMonth: OptionMonth;
  selectedMonthViewValue: string;
  groupingUnits = [
    [
      'week',                         // unit name
      [1]                             // allowed multiples
    ],
    [
      'month',
      [1]
    ]
  ];

  ngOnInit() {
    this.selectedOptionMonth = {
      value: this.currentDateRange,
      viewValue: this.datePipe.transform(this.currentDateRange.startDate, 'MMMM yyyy')
    };
    const selectedDateRange = this.selectedOptionMonth.value;
    this.selectedMonthViewValue = this.selectedOptionMonth.viewValue;
    this.instantiateOptionMonths();
    this.LoadChartObject(selectedDateRange.startDate, selectedDateRange.endDate);
  }

  private addMonths(date: Date, months: number) {
    const newDate = date;
    newDate.setMonth(newDate.getMonth() + months);
    return (newDate);
  }

  private addToOptionMonths(startDate: Date, endDate: Date, negativeDirection: boolean) {
    const dates: Date[] = [];
    let currentDate = new Date(startDate);
    if (!negativeDirection) {
      while (currentDate <= endDate) {
        dates.push(currentDate);
        this.optionMonths.push({
          value: {
            startDate: new Date(currentDate),
            endDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 23, 59, 59, 999)
          },
          viewValue: this.datePipe.transform(currentDate, 'MMMM yyyy')
        });
        currentDate = this.addMonths(currentDate, 1);
      }
    }
  }

  private alterSelectedMonthOption(viewValue: string) {
    const selectedValue = this.optionMonths.filter(f => f.viewValue === viewValue);

    if (selectedValue.length === 0) {
      return;
    }

    this.selectedOptionMonth = {
      value: {
        startDate: selectedValue[0].value.startDate,
        endDate: selectedValue[0].value.endDate
      },
      viewValue: viewValue
    };
  }

  public reloadChart($event: MatSelectChange) {
    this.alterSelectedMonthOption(this.selectedMonthViewValue);
    const selectedDateRange = this.selectedOptionMonth.value;
    this.instantiateOptionMonths();
    this.LoadChartObject(selectedDateRange.startDate, selectedDateRange.endDate);
  }

  private instantiateOptionMonths() {
    this.optionMonths = [];

    const currentlySelectedDate = this.selectedOptionMonth.value.startDate;
    const startDate = new Date(currentlySelectedDate);
    const endDate = new Date(currentlySelectedDate);
    startDate.setMonth(startDate.getMonth() - 5);
    endDate.setMonth(endDate.getMonth() + 5);
    const today = new Date();
    if (endDate > today) {
      endDate.setMonth(today.getMonth());
    }
    this.addToOptionMonths(startDate, endDate, false);
  }

  private mergeServiceCalls(isMocked: boolean, startDate ?: any, endDate ?: any, category1Id ?: any, category2Id ?: any, category3Id ?: any,
    statuses ?: any, calculatedIntervals ?: any, userGroupsId ?: any, concatPivotFields ?: any, debug ?: any): Observable<FinalModel> {
    let compeltionModel: MonitorsSlaTeamProductivityCompletionMonitorModel;
    let faceTimeModel: MonitorsSlaTeamProductivityFacetimeMonitorModel;
    const options = {
      category1Id: category1Id,
      category2Id: category2Id,
      category3Id: category3Id,
      statuses: statuses,
      calculatedIntervals: calculatedIntervals,
      userGroupsId: userGroupsId,
      concatPivotFields: concatPivotFields,
      debug: debug
    };
    if (isMocked) {
      this.mockCompletionService.getMockedSlaTeamProductivityCompletionCounts().subscribe(x => {
        compeltionModel = x;
      });
      this.mockFaceTimeService.getMockedSlaTeamProductivityFacetimeCounts().subscribe(x => {
        faceTimeModel = x;
      });
    } else {
      this.monitorCompletionService.getTeamProductivityCompletionSlaMonitorWorkCounts(startDate, endDate, options).subscribe(x => {
        compeltionModel = x;
      });
      this.monitorFacetimeService.getTeamProductivityFacetimeSlaMonitorWorkCounts(startDate, endDate, options).subscribe(x => {
        faceTimeModel = x;
      });
    }
    const finalModel: FinalModel = {
      completionModel: compeltionModel,
      faceTimeModel: faceTimeModel
    };
    return of(finalModel);
  }

  public LoadChartObject(startDate: any, endDate: any, category1Id ?: any, category2Id ?: any, category3Id ?: any, statuses ?: any,
    calculatedIntervals ?: any, userGroupsId ?: any, concatPivotFields ?: any, debug ?: any) {
      this.finalModel.subscribe(
        model => {
          this.chartOptions = {
            ...this.chartOptions,
            xAxis: this.extractXAxis(),
            series: this.extractSeries(model.completionModel, model.faceTimeModel)
          };
          this.model = model;
        }
      );
  }


  private extractXAxis(): any {
      const output = {
        id: 'dateaxis',
        type: 'datetime',
        ordinal: false,
        mintickInterval: 24 * 3600 * 1000,
        title: { rotation: -45 },
        labels: {
         format: '<b class="xAxisLabel">{value:%e %b %y}</b>'
        }
      };
      return output;
  }

  private extractSeries(completionModel: MonitorsSlaTeamProductivityCompletionMonitorModel,
    facetimeModel: MonitorsSlaTeamProductivityFacetimeMonitorModel): any {
    const series = [];
    let userSerieses = new Array();
    const users = [];
    if (typeof(facetimeModel) !== 'undefined') {
      facetimeModel.data.forEach(element => {
        element.userFacetimeCounts.forEach(x => {
          if (!users.includes(x.userName)) {
            users.push(x.userName);
          }
        });
      });
      let dataSeries = [];

      //TODO:
      // users.forEach(element => {
      //   facetimeModel.data.forEach(x => {
      //     const interval = x.interval.getTime();
      //     x.userFacetimeCounts.forEach(y => {
      //       if (y.userName === element) {
      //         dataSeries.push([interval, y.faceTimeCount]);
      //       }
      //     });
      //   });
      //   userSerieses.push({
      //     userName: element,
      //     valueSeries: dataSeries
      //   });
      //   dataSeries = [];
      // });
      userSerieses.forEach(x => {
        series.push(
          {
            id: users.length + userSerieses.indexOf(x) + 1 + '',
            name: x.userName,
            color: this.determineColorFromIndex(userSerieses.indexOf(x)),
            data: x.valueSeries,
            drilldown: true,
            type: 'line',
            yAxis: 0,
            linkedTo: users.indexOf(x.userName) + '',
            stack: 'faceTime',
            dataGrouping: {
              units: this.groupingUnits
            },
            showInNavigator: true
          });
      });
    }
    userSerieses = [];
    if (typeof(completionModel) !== 'undefined') {
      completionModel.data.forEach(element => {
        element.userWorkCounts.forEach(x => {
          if (!users.includes(x.userName)) {
            users.push(x.userName);
          }
        });
      });
      let dataSeries = [];
      // users.forEach(element => {
      //   completionModel.data.forEach(x => {
      //     const interval = x.interval.getTime();
      //     x.userWorkCounts.forEach(y => {
      //       if (y.userName === element) {
      //         dataSeries.push([interval, y.completionCount]);
      //       }
      //     });
      //   });
      //   userSerieses.push({
      //     userName: element,
      //     valueSeries: dataSeries
      //   });
      //   dataSeries = [];
      // });
      userSerieses.forEach(x => {
        series.push(
          {
            id: userSerieses.indexOf(x) + '',
            name: x.userName,
            color: this.determineColorFromIndex(userSerieses.indexOf(x)),
            data: x.valueSeries,
            drilldown: true,
            type: 'column',
            yAxis: 1,
            stack: 'completion',
            dataGrouping: {
              units: this.groupingUnits
            }
          });
      });
    }
    return (series);
  }

  private determineColorFromIndex(index: number) {
    const greyLight = '#92A8CD';
    const blueLight = '#3D96AE';
    const blueDark = '#5F8BC0';
    const purpleDark = '#80699B';
    const orangeDark = '#FF7300';
    const greenLight = '#B5CA92';
    const greenDark = '#89A54E';
    const redDark = '#AA4643';
    const brownLight = '#A47D7C';
    const pinkLight = '#CC92CC';
    const colourList = [blueDark, redDark, greenDark, purpleDark, blueLight, orangeDark, greyLight, greenLight, brownLight, pinkLight];
    return colourList[index % 10];
  }

  private drillDown(event) {
    alert(event) ;
  }

  createChartOptions() {
    const _this: E5coreUiMonitorSlaTeamProductivityHighchartsComponent = this;
    return {
      chart: {
        alignTicks: false,
        events: {
          drilldown: function (event) {
              _this.drillDown(event);
          }
        }
      },
      exporting: {
        enabled: false
      },
      title: {
        text: 'Team Productivity',
        style: {
          'fontSize': '16px',
          'font-weight': 'bold'
        }
      },
      xAxis: {
        categories: [],
        title: { rotation : -45},
      },
      yAxis: [{
        min: 0,
        title: {
          text: 'Work FaceTime Count',
        },
        labels: {
          enabled: false
        },
        height: 150,
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
            color: 'gray'
          }
        }
      },
      {
        min: 0,
        title: {
          text: 'Work Completed',
        },
        height: 95,
        top: 200,
        opposite: false,
        labels: {
          enabled: false
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
            color: 'gray'
          }
        }
      }],
      legend: {
        align: 'center',
        x: -30,
        verticalAlign: 'top',
        y: 25,
        floating: true,
        backgroundColor: 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
        itemStyle: {
          fontSize: '12px',
          font: '12pt',
        }
      },
      navigator: {
        adaptToUpdatedData: false,
        enabled: true,
        xAxis: {
          id: 'dateaxis',
          type: 'datetime',
          ordinal: false,
          labels: {
            format: '{value:%e %b %y}'
          },
          minTickInterval: 24 * 3600 * 1000
        },
        series: {
          marker: true
        }
      },
      rangeSelector: {
        enabled: true,
        allButtonsEnabled: true,
        verticalAlign: 'top',
        buttons: [
          {
            type: 'week',
            count: 1,
            text: '1W'
          },
          {
            type: 'all',
            text: 'All'
          }
        ],
        selected: 2,
        inputEnabled: true
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function() {
          return _this.formatterFunction(this);
        }
      },
      plotOptions: {
        column: {
          stacking: 'normal'
        },
        series: {
            // stacking: 'normal',
            dataLabels: {
              enabled: true,
              align: 'center',
              color: '#FFFFFF'
            },
            dataGrouping: {
              units: this.groupingUnits
            },
            events: {
              legendItemClick: function(event: MouseEvent) {
                _this.onClick(this, event);
              }
            }
          }
      },
      series: [{
        name: 'test',
        type: 'line',
        data: [0]
      }]
    };
  }

  public onClick(eventThis: any, eventData: MouseEvent) {
    const chart = eventThis.chart,
    series = chart.series,
    display = eventThis.visible ? false : true;

    eventThis.setVisible(display, false);
    eventThis.linkedSeries.setVisible(display, false);
    chart.redraw(true); // "false" forces redraw without animations
    eventThis.preventDefault();
  }

  userFriendlyTime(value: any, timeType: any, fullTextLabels: any, showMiddleZeroes: any, precisionName: any, showZeros: any) {
    let seconds = 0;

    // convert initial units into seconds
    switch (timeType) {
        case 'seconds':
            seconds = value;
            break;
        case 'minutes':
            seconds = value * 60;
            break;
        case 'hours':
            seconds = value * 60 * 60;
            break;
        case 'days':
            seconds = value * 60 * 60 * 24;
            break;
        default:
            throw new Error('Unsupported time type');
    }

    // define available units
    const units = {
        'year': { seconds: 24 * 60 * 60 * 365, shortName: 'y' },
        'month': { seconds: 24 * 60 * 60 * 30, shortName: 'mth' },
        'week': { seconds: 24 * 60 * 60 * 7, shortName: 'w' },
        'day': { seconds: 24 * 60 * 60, shortName: 'd' },
        'hour': { seconds: 60 * 60, shortName: 'h' },
        'minute': { seconds: 60, shortName: 'm' },
        'second': { seconds: 1, shortName: 's' }
    };

    const result = [];

    for (const name of Object.keys(units)) {
        const unitObj = units[name];
        const p = Math.floor(seconds / unitObj.seconds);
        if (fullTextLabels) {
            if (p === 1) {
              result.push(p + ' ' + name);
            } else if (p >= 2) {
              result.push(p + ' ' + name + 's');
            } else if (showMiddleZeroes && p === 0 && result.length > 0) {
              result.push(0 + ' ' + name + 's');
            }
        } else if (p >= 1) {
          result.push(p + unitObj.shortName);
        } else if (showMiddleZeroes && p === 0 && result.length > 0) {
          result.push(0 + unitObj.shortName);
        }
        seconds %= unitObj.seconds;
        if (precisionName && precisionName === name) {
          break;
        }
        // if (p > 0) console.log(result[result.length - 1]);
    }
    let resultStr = result.join(' ');
    if (!resultStr && showZeros) {
        if (precisionName) {
            if (fullTextLabels) {
              resultStr = '0' + ' ' + precisionName + 's';
            } else {
              resultStr = '0' + units[precisionName].shortName;
            }
        } else {
          resultStr = '-';
        }
    }
    return resultStr;
}

  public formatterFunction(eventThis: any): string {
    const workCompletion = [];
    const faceTime = [];
    eventThis.points.forEach(x => {
      if (x.point.series.options.stack === 'completion') {
        workCompletion.push(x);
      } else {
        faceTime.push(x);
      }
    });
    const headerString =
    `<b>${this.datePipe.transform(eventThis.x, 'dd MMM yyyy')}</b>
    `;
    const headerRow =
   `<table>
      <tr>
        <td style="text-align: center;">User</td>
        <td style="text-align: center;">FaceTime</td>
        <td style="text-align: center;">Completion</td>
      </tr>`;
    let seriesStrings = '';
    for (let i = 0; i < workCompletion.length; i++) {
      const seriesString =
     `<tr>
        <td>
          <span style="text-align: center; color: ${this.determineColorFromIndex(i)};">${workCompletion[i].series.name}</span>
        </td>
        <td>
          <span style="text-align: center;">${this.userFriendlyTime(faceTime[i].y, 'seconds', false, false, 'second', true)}</span>
        </td>
        <td>
          <span style="text-align: center;">${workCompletion[i].y}</span>
        </td>
      </tr>`;
      seriesStrings = seriesStrings + seriesString;
    }
    return headerString + headerRow + seriesStrings + '</table>';
  }

  injectMockInformation(startDate: string, endDate: string) {

  }

  onNavigationCategoryClick(categoryName) {

  }

}



